// TODO: this file should be deleted in the future and all custom types should be replaced by autogenerated ones

import { definitions } from '@/api/__generated__/schema.ts';

export interface Property {
  id: number;
  code: string;
  title: string;
  name: string;
  area: number;
  due_day_delay: number;
  first_day_of_week: number;
  week_offset: number;
}

export enum Permission {
  CAN_CANDIDATES = 'can_candidates',
  QR_NOTIFICATIONS = 'qr_notifications',
  CAN_POSITIONS = 'can_positions',
  CAN_REQUEST_EMPLOYEES = 'can_request_employees',
  CAN_BILLING = 'can_billing',
}

export interface Access {
  can_archive: boolean;
  can_send_invoice: boolean;
  permissions: Permission[];
}

export type CompanyInfo = Omit<
  definitions['CompanyInfo'],
  'property' | 'manager' | 'access'
> & {
  property: Property;
  manager: definitions['ManagerSerializerMU'];
  access: Access;
};

export interface ScheduleCell {
  to?: string | null;
  from?: string | null;
}

export type ScheduleEmployment = Omit<
  definitions['ScheduleEmployment'],
  'employee'
> & {
  employee: {
    id?: number;
    name: string;
    first_name?: string;
    last_name?: string;
    photo?: string;
  };
};

export type Schedule = Omit<
  definitions['Schedule'],
  'days' | 'schedule' | 'employment'
> & {
  days: string[];
  schedule: ScheduleCell[];
  employment: ScheduleEmployment;
};

export const EmploymentStatus = {
  NO_ACTION: 'NO_ACTION',
  PAPERWORK_PROCESSING: 'PAPERWORK_PROCESSING',
  BACKGROUND_CHECK: 'BACKGROUND_CHECK',
  ON_STAFF: 'ON_STAFF',
  SEPARATED: 'SEPARATED',
  TRANSFERRED: 'TRANSFERRED',
} as const;
